var map = {
	"./Admins.vue": [
		"6271",
		"chunk-362d"
	],
	"./Banners.vue": [
		"68df",
		"68df"
	],
	"./Categories.vue": [
		"58c2",
		"58c2"
	],
	"./Collections.vue": [
		"4355",
		"4355"
	],
	"./Coupons.vue": [
		"f329",
		"f329"
	],
	"./Dashboard.vue": [
		"7277",
		"chunk-7405"
	],
	"./DeliveryExecutives.vue": [
		"2065",
		"chunk-d3fb"
	],
	"./Login.vue": [
		"a55b",
		"chunk-bf43"
	],
	"./Orders.vue": [
		"159d",
		"chunk-a87f",
		"chunk-3772"
	],
	"./Orders/cancelled-orders.vue": [
		"7b25",
		"chunk-1c5f"
	],
	"./Orders/delivered-orders.vue": [
		"cb4c",
		"chunk-25de"
	],
	"./Orders/new-orders.vue": [
		"3d04",
		"chunk-a87f"
	],
	"./Orders/pending-delivery.vue": [
		"0ddd",
		"0ddd"
	],
	"./Orders/pending-labels.vue": [
		"4265",
		"chunk-e362"
	],
	"./Orders/pending-packaging.vue": [
		"96c5",
		"96c5"
	],
	"./Orders/pending-pickup.vue": [
		"1b02",
		"1b02"
	],
	"./PaymentConfig.vue": [
		"15b0",
		"chunk-4877"
	],
	"./Products.vue": [
		"e6dc",
		"chunk-1d33"
	],
	"./Promotions.vue": [
		"364e",
		"364e"
	],
	"./Settings.vue": [
		"26d3",
		"chunk-273f"
	],
	"./Settings/Policies.vue": [
		"28be",
		"chunk-3682"
	],
	"./Settings/Shipping.vue": [
		"b142",
		"chunk-0137"
	],
	"./Slider.vue": [
		"18bf",
		"chunk-a812"
	],
	"./UserProfile.vue": [
		"4a39",
		"4a39"
	],
	"./Vendors.vue": [
		"9850",
		"chunk-7b3e"
	],
	"./date-range-picker.vue": [
		"aae5",
		"aae5"
	],
	"./ss.vue": [
		"8353",
		"8353"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;